export default function FinalCTA() {
  const handleWhatsApp = () => {
    window.open('https://wa.me/13056840894', '_blank');
  };

  const handleCalendar = () => {
    window.open('https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0', '_blank');
  };

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Fondo con degradado premium */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#050505] via-[#1C1C1C] to-[#050505]">
        <div className="absolute inset-0 bg-gradient-to-tr from-[#D4AF37]/20 via-transparent to-[#D4AF37]/10"></div>
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#D4AF37]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#D4AF37]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Icono destacado */}
        <div className="w-24 h-24 bg-gradient-to-br from-[#D4AF37] to-[#F4D03F] rounded-full flex items-center justify-center mx-auto mb-8 shadow-2xl shadow-[#D4AF37]/50">
          <i className="ri-rocket-line text-[#050505] text-4xl"></i>
        </div>

        {/* Título principal */}
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          ¿Listo para Acceder a
          <span className="block text-[#D4AF37] mt-2">Capital Estratégico?</span>
        </h2>

        {/* Subtítulo */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Da el siguiente paso hacia el crecimiento de tu negocio o inversiones con capital a 0% de interés promocional
        </p>

        {/* Botones principales */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <button
            onClick={handleCalendar}
            className="group relative px-12 py-6 bg-[#D4AF37] text-[#050505] font-bold text-xl rounded-lg overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#D4AF37]/50 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10 flex items-center gap-3">
              <i className="ri-calendar-check-line text-2xl"></i>
              Agenda tu Consulta Gratuita
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>

          <button
            onClick={handleWhatsApp}
            className="px-12 py-6 bg-transparent border-2 border-[#D4AF37] text-[#D4AF37] font-bold text-xl rounded-lg transition-all duration-300 hover:bg-[#D4AF37] hover:text-[#050505] hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-3">
              <i className="ri-whatsapp-line text-2xl"></i>
              Escríbenos por WhatsApp
            </span>
          </button>
        </div>

        {/* Información de contacto */}
        <div className="mb-12">
          <p className="text-gray-400 mb-2">WhatsApp directo:</p>
          <a
            href="https://wa.me/13056840894"
            className="text-[#D4AF37] text-xl font-semibold hover:text-[#F4D03F] transition-colors duration-300 cursor-pointer"
          >
            +1 (305) 684-0894
          </a>
        </div>

        {/* Separador */}
        <div className="flex items-center gap-4 max-w-md mx-auto mb-12">
          <div className="flex-1 h-px bg-[#D4AF37]/30"></div>
          <span className="text-gray-400">o</span>
          <div className="flex-1 h-px bg-[#D4AF37]/30"></div>
        </div>

        {/* Enlace secundario a crédito */}
        <div className="max-w-2xl mx-auto p-8 bg-[#1C1C1C]/50 border border-[#D4AF37]/30 rounded-2xl backdrop-blur-sm">
          <div className="flex items-center justify-center gap-3 mb-4">
            <i className="ri-information-line text-[#D4AF37] text-2xl"></i>
            <h3 className="text-xl font-bold text-white">
              ¿Primero Necesitas Arreglar tu Crédito?
            </h3>
          </div>
          <p className="text-gray-300 mb-6 leading-relaxed">
            Si tu perfil crediticio aún no está listo para el Funding, podemos ayudarte a reestructurarlo primero. Es el paso previo necesario para acceder al capital.
          </p>
          <a
            href="https://credit.cashflow.vip/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-transparent border-2 border-[#D4AF37] text-[#D4AF37] font-bold rounded-lg hover:bg-[#D4AF37] hover:text-[#050505] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Conoce nuestro servicio de crédito
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Mensaje de confianza final */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-gray-400">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-[#D4AF37]"></i>
            <span>100% Confidencial</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-[#D4AF37]"></i>
            <span>Respuesta Rápida</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-customer-service-line text-[#D4AF37]"></i>
            <span>Acompañamiento Profesional</span>
          </div>
        </div>
      </div>

      {/* Footer con copyright */}
      <div className="relative z-10 mt-20 pt-8 border-t border-[#D4AF37]/20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 Cashflow VIP. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
